import React from 'react';
import { Label } from '@/components/atoms/texts/label';
import PrintErrorMessage from '@/components/organisms/feedback/PrintErrorMessage';
import { Input } from '@/components/ui/input';
import { Switch } from '@/components/ui/switch';

export default function StatementOperationAlwaysEditableForm({
    alwaysEditableForm,
    setAlwaysEditableForm,
    submissionError,
}) {
    return (
        <div className="flex flex-col gap-secondDegree p-thirdDegree">
            <div className="flex items-center gap-secondDegree">
                <Label fontWeight="bold" message="consultants.expense.includeOverflow?" />
                <Switch
                    checked={!!alwaysEditableForm.impactsOverflow}
                    onCheckedChange={(checked) => setAlwaysEditableForm((prev) => ({ ...prev, impactsOverflow: checked }))}
                />
            </div>
            <div className="grid grid-cols-4 items-center gap-secondDegree w-full">
                <Label fontWeight="bold" className="col-span-1" message="consultants.expense.comment" />
                <Input
                    className="col-span-3"
                    value={alwaysEditableForm.comment || ''}
                    onChange={(e) => setAlwaysEditableForm((prev) => ({ ...prev, comment: e.target.value }))}
                />
            </div>
            {submissionError && <PrintErrorMessage error={submissionError} />}
        </div>
    );
}
